import CONSTANTS from "@/store/constants";
import _truncate from "truncate-html";

const filters = {
  hhTruncateHTML: function(html, stop, ellipsis) {
    if (!html || html == "null") return "";
    return _truncate(html, {
      length: stop,
      stripTags: true,
      byWords: true,
      decodeEntities: true,
      // We want to add an ellipsis to everything, so we will add it afterwards
      ellipsis: ellipsis ? ellipsis : ""
    });
  },
  consistentStylesKb: function(html) {
    if (!html || html == "null") return "";
    return html
      .replace(/Help Hub/g, "Employee Hub")
      .replace(/font-size: 14pt/g, "font-size: 14px")
      .replace(/font-size: 18pt/g, "font-size: 18px")
      .replace(/font-size: 19px/g, "font-size: 14px")
      .replace(/font-size: 24px/g, "font-size: 18px")
      .replace(/font-size: 13px/g, "font-size: 14px")
      .replace(/font-size: large/g, "");
  },
  pascalCase: function(value) {
    return value.toString().replace(/(\w)(\w*)/g, function(g0, g1, g2) {
      return g1.toUpperCase() + g2.toLowerCase();
    });
  }
};

export default filters;



// WEBPACK FOOTER //
// ./src/utils/filter.js